import { render, staticRenderFns } from "./PrjAlert.vue?vue&type=template&id=7850ee08&"
import script from "./PrjAlert.vue?vue&type=script&lang=ts&"
export * from "./PrjAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports